import { compose, setDisplayName, withProps } from 'recompose';

import {
  KEY_TEXTFIELD_FONT_COLOR,
  KEY_TEXTFIELD_FONT_SIZE,
  KEY_TEXTFIELD_FONT_STYLE,
  KEY_TEXTFIELD_FONT_WEIGHT,
  KEY_TEXTFIELD_TEXT_DECORATION,
  KEY_TEXTFIELD_TEXT_TRANSFORM,
} from '../../const/keysBlockStyling';

const StylingToCSSTextfieldInner = withProps(
  ({
    styling: {
      [KEY_TEXTFIELD_FONT_COLOR]: color,
      [KEY_TEXTFIELD_FONT_SIZE]: fontSize,
      [KEY_TEXTFIELD_FONT_STYLE]: fontStyle,
      [KEY_TEXTFIELD_FONT_WEIGHT]: fontWeight,
      [KEY_TEXTFIELD_TEXT_DECORATION]: textDecoration,
      [KEY_TEXTFIELD_TEXT_TRANSFORM]: textTransform,
    } = {},
  }) => ({
    styleTextfieldInner: {
      color,
      fontSize,
      fontStyle,
      fontWeight,
      textDecoration,
      textTransform,
    },
  }),
);

export default compose(
  setDisplayName('StylingToCSSTextfieldInner'),
  StylingToCSSTextfieldInner,
);
